import { styled } from '@clickcease/cc-client-components-lib'
import image from '../../assets/images/limited-offer-banner-pink-shape.svg'

export const BannerWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  flex: '1',
  height: '242px',
  padding: '$16 $12 $9 $16',
  marginBottom: '$10',
  borderRadius: '$medium',
  color: '$black',
  overflow: 'hidden',
  background:
    'radial-gradient(18.16% 100.5% at 24% 44.25%, rgba(136, 179, 231, 0) 0%, rgba(136, 179, 231, 0.33) 100%)',
  zIndex: '0',

  '&::after': {
    content: '" "',
    position: 'absolute',
    height: '100%',
    width: '45%',
    top: '0',
    right: '0',
    background: `url(${image})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
  },
})

export const LeftSideWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
})

export const RightSideWrapper = styled('div', {
  display: 'flex',
  width: '35%',
  zIndex: '1',
  justifyContent: 'flex-end',
  alignItems: 'center',
})

export const Quote = styled('span', {
  fontSize: '$h1',
  fontWeight: '$sb',
  color: '$white',
  maxWidth: '330px',
  textAlign: 'center',
  marginRight: '50px',
  lineHeight: '1.5',

  '@laptop': {
    marginRight: 'unset',
  },
})

export const BannerTitle = styled('h2', {
  lineHeight: '1',
})

export const BannerTitleTextSmall = styled('span', {
  fontSize: '$h5',
  fontWeight: '$l',
  display: 'block',
})

export const BannerTitleText = styled('span', {
  fontSize: '2.5rem',
  fontWeight: '$b',
  marginRight: '$6',
})

export const BannerTitleTextPink = styled(BannerTitleText, {
  color: '$primaryColor',
})

export const BannerDescription = styled('div', {
  display: 'flex',
  gap: '$5',
})

export const BannerDescriptionText = styled('span', {
  fontSize: '$h3',
  fontWeight: '$sb',
})

export const BannerDescriptionTextPink = styled(BannerDescriptionText, {
  color: '$primaryColor',
})

export const CustomerFaceImage = styled('img', {
  position: 'absolute',
  left: '55%',
  top: '112px',
  zIndex: '1',
})

export const StyledLink = styled('a', {
  color: '$primaryColor',
  textDecoration: 'underline',
  cursor: 'pointer',
})

export const NoteText = styled('span', {
  fontSize: '$md',
  fontWeight: '$l',
})

export const NoteBold = styled('div', {
  fontSize: '$md',
  marginTop: '$10',
  fontWeight: '$r',
})
